import React from 'react';
import { Icon } from '@chakra-ui/react';

export const FacebookLogo = () => {
	return (
		<Icon
			width="7.5px"
			height="12px"
			viewBox="0 0 5 8"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.10674 0.949219H3.09912C2.65372 0.949219 2.22656 1.12615 1.91162 1.4411C1.59667 1.75604 1.41974 2.1832 1.41974 2.6286V3.63623H0.412109V4.97973H1.41974V7.66674H2.76324V4.97973H3.77087L4.10674 3.63623H2.76324V2.6286C2.76324 2.53952 2.79863 2.45409 2.86162 2.3911C2.92461 2.32811 3.01004 2.29272 3.09912 2.29272H4.10674V0.949219Z"
				fill="white"
			/>
		</Icon>
	);
};

export default FacebookLogo;
